<template>
  <v-card>
    <v-tabs v-model="selected" background-color="blue-grey lighten-5" right>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab to="/usuario">Usuários</v-tab>
      <v-tab to="/cargo">Cargos</v-tab>
      <v-tab to="/departamento">Departamentos</v-tab>
      <v-tab to="/perfil">Perfis</v-tab>
      <v-tab to="/permissao">Permissões</v-tab>
    </v-tabs>
  </v-card>
</template>
<script>
export default {
  name: "criarAcesso",
  data: () => ({
    selected: null,
  }),
  props: {
    active_tab: Object,
  },
  mounted() {
    this.selected = this.active_tab
  },
};
</script>